module.exports = __webpack_public_path__ + "static/media/UP_L1.83279d14.svg";